async function getSpecialists(filter = null, location = null) {
    try {
        let queryParams = [];
        if (filter) {
            queryParams.push(`filter=${filter}`);
        }
        if (location) {
            queryParams.push(`location=${location}`)
        }

        const response = await fetch(`/api/v1/psychologists${queryParams.length ? '?' + queryParams.join('&') : ''}`);
        if (response.status !== 200) {
           throw new Error('Не удалось получить список специалистов');
        }
        return await response.json();
    } catch (e) {
        throw new Error(e);
    }
}

export default getSpecialists;
